import Snackbar from "@mui/joy/Snackbar"
import IconButton from "@mui/joy/IconButton"
import Typography from "@mui/joy/Typography"

import CheckIcon from "@common/icons/CheckIcon"
import ChevronRightRoundedIcon from "@common/icons/ChevronRightRoundedIcon"

import NotificationSymbol from "./NotificationSymbol"
import {
  type NotificationOptions,
  type NotificationProps,
  baseNotificationProps,
} from "./utils"

type SuccessNotificationProps = NotificationProps & NotificationOptions

const SuccessNotification = (props: SuccessNotificationProps) => {
  return (
    <Snackbar
      {...baseNotificationProps(props.toast)}
      startDecorator={
        <NotificationSymbol color="success">
          <CheckIcon fontSize="xs" sx={{ fill: "white" }} />
        </NotificationSymbol>
      }
      endDecorator={
        props.href && (
          <IconButton
            variant="plain"
            color="neutral"
            size="md"
            component="a"
            href={props.href}
            target="_blank"
            rel="noopener"
            aria-label="notification more"
          >
            <ChevronRightRoundedIcon
              sx={({ palette }) => ({ color: palette.text.secondary })}
            />
          </IconButton>
        )
      }
    >
      <Typography level="title-md" textColor="text.primary">
        {props.message}
      </Typography>
    </Snackbar>
  )
}

export default SuccessNotification
